import { Action } from '@ngrx/store';
import { InterventionHistory } from '../models/intervention-history.model';
import { QueryParamsModel } from '../../../../core/_base/crud';

export enum InterventionHistoryActionTypes {
  InterventionHistoryPageRequested = '[InterventionHistory List Page] InterventionHistory Page Requested',
  InterventionHistoryPageLoaded = '[InterventionHistory API] InterventionHistory Page Loaded',
  InterventionHistoryPageCancelled = '[InterventionHistory API] InterventionHistory Page Cancelled',
  InterventionHistoryPageToggleLoading = '[InterventionHistory] InterventionHistory Page Toggle Loading',
  InterventionHistoryActionToggleLoading = '[InterventionHistory] InterventionHistory Action Toggle Loading',
  ThrowInterventionHistoryError = '[InterventionHistory] Throw InterventionHistory Error',
  ClearInterventionHistoryErrors = '[InterventionHistory] Clear InterventionHistory Errors',
  FireInterventionHistorySuccess = '[InterventionHistory] Fire Successful',
}

export class InterventionHistoryPageRequested implements Action {
  readonly type = InterventionHistoryActionTypes.InterventionHistoryPageRequested;

  constructor(public payload: { page: QueryParamsModel; patient_id: any; drp_id: any }) {}
}

export class InterventionHistoryPageLoaded implements Action {
  readonly type = InterventionHistoryActionTypes.InterventionHistoryPageLoaded;

  constructor(
    public payload: {
      interventionHistory: InterventionHistory[];
      totalCount: number;
      page: QueryParamsModel;
    },
  ) {}
}

export class InterventionHistoryPageCancelled implements Action {
  readonly type = InterventionHistoryActionTypes.InterventionHistoryPageCancelled;
}

export class InterventionHistoryPageToggleLoading implements Action {
  readonly type = InterventionHistoryActionTypes.InterventionHistoryPageToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class InterventionHistoryActionToggleLoading implements Action {
  readonly type = InterventionHistoryActionTypes.InterventionHistoryActionToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class ThrowInterventionHistoryError implements Action {
  readonly type = InterventionHistoryActionTypes.ThrowInterventionHistoryError;

  constructor(public payload: { error: any }) {}
}

export class ClearInterventionHistoryErrors implements Action {
  readonly type = InterventionHistoryActionTypes.ClearInterventionHistoryErrors;
}

export class FireInterventionHistorySuccess implements Action {
  readonly type = InterventionHistoryActionTypes.FireInterventionHistorySuccess;

  constructor(public payload: { action_type: any }) {}
}

export type InterventionHistoryActions =
  | InterventionHistoryPageRequested
  | InterventionHistoryPageLoaded
  | InterventionHistoryPageCancelled
  | InterventionHistoryPageToggleLoading
  | InterventionHistoryActionToggleLoading
  | ThrowInterventionHistoryError
  | FireInterventionHistorySuccess
  | ClearInterventionHistoryErrors;
